import { useQuery } from "@tanstack/react-query";
import CampaignsService from "./campaigns.service";

export const useLocalizedMarkets = (orderWindowId?: number) => {
  return useQuery({
    queryKey: ["localizedMarkets", orderWindowId],
    queryFn: () =>
      CampaignsService.getLocalizedChildMarketsForOW({
        id: orderWindowId,
      }),
    enabled: !!orderWindowId,
  });
};